import React from 'react';
import { WifiOff } from 'lucide-react';
import { usePWA } from '../../hooks/usePWA';

export const OfflineIndicator: React.FC = () => {
  const { isOnline } = usePWA();

  if (isOnline) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 bg-orange-500 text-white px-4 py-2 z-50 flex items-center justify-center space-x-2">
      <WifiOff className="w-4 h-4" />
      <span className="text-sm font-medium">
        Mode hors ligne - Certaines fonctionnalités peuvent être limitées
      </span>
    </div>
  );
};

